module.exports = __webpack_public_path__ + "img/category.01e4496b.svg";